import script from "./Staking.vue?vue&type=script&setup=true&lang=js"
export * from "./Staking.vue?vue&type=script&setup=true&lang=js"

import "./Staking.vue?vue&type=style&index=0&id=55adaa80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55adaa80"]])

export default __exports__